import { render } from "./logo-layer.vue?vue&type=template&id=e370ed10"
import script from "./logo-layer.vue?vue&type=script&lang=js"
export * from "./logo-layer.vue?vue&type=script&lang=js"

import "./logo-layer.vue?vue&type=style&index=0&id=e370ed10&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__